<template>
  <div class="preview-cover van-ellipsis">
    <div class="preview-cover-placeholder">
      <van-icon name="video" />
    </div>
    <van-image
      v-show="firstFrameImage"
      width="100%"
      height="100%"
      fit="cover"
      :show-loading="true"
      lazy-load
      :src="firstFrameImage"
    >
      <template v-slot:loading>
        <van-loading type="spinner" size="20" />
      </template>
    </van-image>
    <span v-show="duration" class="preview-cover-duration">
      {{ duration }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'UploadVideoPreview',
  props: {
    firstFrameImage: {
      type: String,
      default: ''
    },
    duration: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-cover {
  width: 100%;
  height: 100%;

  &-placeholder {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    background-color: #f2f2f2;
    font-size: 22px;
    color: var(--main-color);
  }

  &-duration {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 24px;
    padding: 0 6px;
    background-color: rgba(0, 0, 0, 0.7);
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    color: #fff;
    border-radius: 10px 0 0 0;
  }
}
</style>
